//Fuel Card
import manageFuelCardTabRedux from "../../views/fuelCardTab/redux/slice";
import manageEditManageFuelCardRedux from "../../views/fuelCardTab/modals/editManageFuelCard/redux/slice";

//Crew
import manageCrewTabRedux from "../../views/crewTab/redux/slice";
import manageCreateEditManageCrewRedux from "../../views/crewTab/modals/createEditManageCrew/redux/slice";
import manageDeleteManageCrewRedux from "../../views/crewTab/modals/deleteManageCrew/redux/slice";

//KeyFobs
import manageKeyFobsTabRedux from "../../views/keyFobsTab/redux/slice";
import manageCreateEditManageKeyFobRedux from "../../views/keyFobsTab/modals/createEditManageKeyFob/redux/slice";
import manageDeleteManageKeyFobRedux from "../../views/keyFobsTab/modals/deleteManageKeyFob/redux/slice";

//Temperature
import manageTemperatureTabRedux from "../../views/temperatureTab/redux/slice";
import manageCreateEditManageTemperatureRedux from "../../views/temperatureTab/modals/createEditManageTemperature/redux/slice";
import manageDeleteManageTemperatureRedux from "../../views/temperatureTab/modals/deleteManageTemperature/redux/slice";

//Equipment
import manageEquipmentTabRedux from "../../views/equipmentTab/redux/slice";
import manageDeleteManageEquipmentRedux from "../../views/equipmentTab/modals/deleteManageEquipment/redux/slice";
import manageCreateEditManageEquipmentRedux from "../../views/equipmentTab/modals/createEditManageEquipment/redux/slice";

//Driver Status
import manageDriverStatusTabRedux from "../../views/driverStatusTab/redux/slice";
import manageDeleteManageDriverStatusRedux from "../../views/driverStatusTab/modals/deleteManageDriverStatus/redux/slice";
import manageCreateEditManageDriverStatusRedux from "../../views/driverStatusTab/modals/createEditManageDriverStatus/redux/slice";

//Locations
import manageLocationsTabRedux from "../../views/locationsTab/redux/slice";
import manageCreateEditManageLocationRedux from "../../views/locationsTab/modals/createEditManageLocation/redux/slice";
import manageDeleteManageLocationsRedux from "../../views/locationsTab/modals/deleteManageLocation/redux/slice";

//Behavior
import manageSearchBehaviorPointsRedux from "../../views/behaviorTab/redux/slice";
import manageCreateUpdateMetricServiceRedux from "../../views/behaviorTab/modals/create/redux/slice";
import manageDeleteMetricServiceRedux from "../../views/behaviorTab/modals/delete/redux/slice";
import manageBehaviorAdvanceFilterRedux from "../../views/behaviorTab/modals/filter/redux/slice"

//Camera Management
import cameraManagementTabRedux from "../../views/cameraManagementTab/redux/slice";
import editCameraManagementPairingRedux from "../../views/cameraManagementTab/modals/editCameraManagementPairing/redux/slice"
import editCameraManagementCameraRedux from "../../views/cameraManagementTab/modals/editCameraManagementCamera/redux/slice"

//Vehicle Status
import manageVehicleStatusTabRedux from "../../views/vehicleStatusTab/redux/slice";
import manageCreateEditManageVehicleStatusRedux from "../../views/vehicleStatusTab/modals/createEditManageVehicleStatus/redux/slice";
import manageDeleteManageVehicleStatusRedux from "../../views/vehicleStatusTab/modals/deleteManageVehicleStatus/redux/slice";

//Inputs
import manageInputsTabRedux from "../../views/inputsTab/redux/slice";
import manageCreateEditManageInputRedux from "../../views/inputsTab/modals/createEditManageInput/redux/slice"
import manageDeleteManageInputRedux from "../../views/inputsTab/modals/deleteManageInput/redux/slice" 

//Assets
import manageAssetTabRedux from '../../views/assetTab/redux/slice';
import manageAssetAdvancedFiltersRedux from '../../views/assetTab/modals/advancedFilters/redux/slice';
import manageAssetCreateEditRedux from '../../views/assetTab/modals/createEditAsset/redux/slice';
import manageAssetDeleteRedux from '../../views/assetTab/modals/deleteAsset/redux/slice';

//Asset Subtype
import manageAssetSubtypesTabRedux from '../../views/assetSubtype/redux/slice'
import manageCreateEditAssetSubtypeRedux from '../../views/assetSubtype/modals/createEditAssetSubtype/redux/slice';
import manageDeleteManageAssetSubtypeRedux from '../../views/assetSubtype/modals/deleteAssetSubtype/redux/slice';

//Work Order Status
import manageWorkOrderStatusTabRedux from '../../views/workOrderStatus/redux/slice';
import manageCreateEditWorkOrderStatusRedux from '../../views/workOrderStatus/modals/createEditManageWorkOrderStatus/redux/slice';
import manageDeleteManageWorkOrderStatusRedux from '../../views/workOrderStatus/modals/deleteManageWorkOrderStatus/redux/slice';

//Work Order Type
import manageWorkOrderTypeTabRedux from '../../views/workOrderType/redux/slice';
import manageCreateEditWorkOrderTypeRedux from '../../views/workOrderType/modals/createEditManageWorkOrderType/redux/slice';
import manageDeleteManageWorkOrderTypeRedux from '../../views/workOrderType/modals/deleteManageWorkOrderType/redux/slice';


export default {
  manageFuelCardTabRedux,
  manageEditManageFuelCardRedux,
  manageCrewTabRedux,
  manageCreateEditManageCrewRedux,
  manageKeyFobsTabRedux,
  manageCreateEditManageKeyFobRedux,
  manageDeleteManageKeyFobRedux,
  manageDeleteManageCrewRedux,
  manageEquipmentTabRedux,
  manageDeleteManageEquipmentRedux,
  manageCreateEditManageEquipmentRedux,
  manageTemperatureTabRedux,
  manageCreateEditManageTemperatureRedux,
  manageDeleteManageTemperatureRedux,
  manageDriverStatusTabRedux,
  manageDeleteManageDriverStatusRedux,
  manageCreateEditManageDriverStatusRedux,
  manageLocationsTabRedux,
  manageCreateEditManageLocationRedux,
  manageDeleteManageLocationsRedux,
  manageInputsTabRedux,
  manageCreateEditManageInputRedux,
  manageDeleteManageInputRedux,
  cameraManagementTabRedux,
  editCameraManagementPairingRedux,
  editCameraManagementCameraRedux,
  manageVehicleStatusTabRedux,
  manageCreateEditManageVehicleStatusRedux,
  manageDeleteManageVehicleStatusRedux,
  manageSearchBehaviorPointsRedux,
  manageCreateUpdateMetricServiceRedux,
  manageDeleteMetricServiceRedux,
  manageBehaviorAdvanceFilterRedux,
  manageAssetTabRedux,
  manageAssetAdvancedFiltersRedux,
  manageAssetCreateEditRedux,
  manageAssetDeleteRedux,
  manageAssetSubtypesTabRedux,
  manageCreateEditAssetSubtypeRedux,
  manageDeleteManageAssetSubtypeRedux,
  manageWorkOrderStatusTabRedux,
  manageCreateEditWorkOrderStatusRedux,
  manageDeleteManageWorkOrderStatusRedux,
  manageWorkOrderTypeTabRedux,
  manageCreateEditWorkOrderTypeRedux,
  manageDeleteManageWorkOrderTypeRedux
};
